import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet, {RequestErrorHandler} from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {ICollectionWorkProject, ICollectionWorkProjectSaveParams} from './useCollectionWorkProject';
import {IContest} from './useContest';

export interface IFileRecord {
  id: number;
  url: string;
  suffix: string;
  name: string;
  sizeMb: string;
}
export enum CollectionWorkProjectStatusConfig {
  开启 = 1,
  关闭 = 2,
  自动 = 3,
}

export interface ICollectionWorkProjectRecord {
  id: number;
  name: string;
  fileRecordId: number;
  collectionWorkProjectId: number;
  collectionWorkProject?: ICollectionWorkProject;
  fileRecord?: IFileRecord;
  user?: IUser;
}

export interface ICollectionWorkProjectRecordSaveParams {
  id?: number;
  name: string;
  collectionWorkProjectId: number;
  fileRecordId: number;
}
export interface ICollectionWorkProjectRecordQueryByProjectIdParams {
  projectId: number;
}
export interface ICollectionWorkProjectRecordListParams {
  collectionWorkId?: number;
}
export interface ICollectionWorkProjectRecordRemoveParams {
  id: number;
}
export interface ICollectionWorkProjectRecordReviewParams {
  id: number;
  score: number;
}
export default class UseCollectionWorkProjectRecord {
  static save() {
    return usePost<ICollectionWorkProjectRecordSaveParams, ICollectionWorkProjectRecord>('collectionWorkProjectRecord/save', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, ICollectionWorkProjectRecord>('collectionWorkProjectRecord/queryById', {});
  }
  static download() {
    return usePost<IQueryByIdParams, ICollectionWorkProjectRecord>('collectionWorkProjectRecord/download', {});
  }
  static review() {
    return usePost<ICollectionWorkProjectRecordReviewParams, any>('collectionWorkProjectRecord/review', {});
  }
  static list() {
    return useGet<ICollectionWorkProjectRecordListParams, ICollectionWorkProjectRecord[]>('collectionWorkProjectRecord/list', {});
  }
  static remove() {
    return usePost<ICollectionWorkProjectRecordRemoveParams, ICollectionWorkProjectRecord>('collectionWorkProjectRecord/remove', {});
  }
  static queryByProjectId(params?: {errorHandler?: RequestErrorHandler}) {
    return useGet<ICollectionWorkProjectRecordQueryByProjectIdParams, ICollectionWorkProjectRecord>('collectionWorkProjectRecord/queryByProjectId', {
      errorHandler: params?.errorHandler,
    });
  }
}
